import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/feedbacks/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/feedbacks/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/feedbacks/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/feedbacks/delete',
    method: 'post',
    data
  })
}

